export const gdpr = {
  routes: [
    {
      path: "/datasource",
      component: () => import("../organization-datasource-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/data-source",
      component: () => import("../workspace-library-datasource-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/data-source",
      component: () => import("../management-library-datasource-view"),
    },
  ],
};
